import { FC, ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type CardProps = {
  children: ReactNode;
  className?: string;
};

export const Card: FC<CardProps> = ({ children, className }) => (
  <div
    className={cx(
      'flex-grow rounded-xl bg-white p-8 pl-10 shadow-sm',
      className,
    )}
  >
    {children}
  </div>
);
